import { Product, SearchProductEntity } from '@generated-client/backend';
import { reatomAsync } from '@reatom/async';
import { action, atom } from '@reatom/core';
import { withLocalStorage } from '@reatom/persist-web-storage';
import { BACKEND_API } from '@trwl/backend.api';

type RecentProduct = Product | SearchProductEntity;

const recentProductsAtom = atom(new Array<RecentProduct>()).pipe(
  withLocalStorage('recentProductsAtom'),
);

const addRecentProductAction = action((ctx, payload: RecentProduct) => {
  recentProductsAtom(ctx, (state) => {
    const productIds = new Set(state.map((p) => p.id));
    if (productIds.has(payload.id))
      return [payload, ...state.filter((item) => item.id !== payload.id)].slice(
        0,
        50,
      );
    return [payload, ...state].slice(0, 50);
  });
}, 'addRecentProductAction');

const updateRecentProductsAction = reatomAsync((ctx) => {
  const products = ctx.get(recentProductsAtom);
  return BACKEND_API.ProductApi.getProductsByIds({
    productIds: products.map((p) => p.id),
  }).then(({ data }) => {
    const productMap = new Map<number, Product>();
    data.forEach((item) => productMap.set(item.id, item));

    recentProductsAtom(ctx, (prev) =>
      prev.map((item) => productMap.get(item.id) || item),
    );
  });
}, 'updateRecentProductsAction');

export {
  recentProductsAtom,
  addRecentProductAction,
  updateRecentProductsAction,
};
